var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:upload-file-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 14.825V18C11 18.2833 11.096 18.521 11.288 18.713C11.48 18.905 11.7173 19.0007 12 19C12.2833 19 12.521 18.904 12.713 18.712C12.905 18.52 13.0007 18.2827 13 18V14.825L13.9 15.725C14 15.825 14.1127 15.9 14.238 15.95C14.3633 16 14.4883 16.021 14.613 16.013C14.7377 16.0043 14.8583 15.975 14.975 15.925C15.0917 15.875 15.2 15.8 15.3 15.7C15.4833 15.5 15.5793 15.2667 15.588 15C15.5967 14.7333 15.5007 14.5 15.3 14.3L12.7 11.7C12.6 11.6 12.4917 11.5293 12.375 11.488C12.2583 11.4467 12.1333 11.4257 12 11.425C11.8667 11.425 11.7417 11.446 11.625 11.488C11.5083 11.53 11.4 11.6007 11.3 11.7L8.7 14.3C8.5 14.5 8.40434 14.7333 8.413 15C8.42167 15.2667 8.52567 15.5 8.725 15.7C8.925 15.8833 9.15834 15.9793 9.425 15.988C9.69167 15.9967 9.925 15.9007 10.125 15.7L11 14.825ZM6 22C5.45 22 4.979 21.804 4.587 21.412C4.195 21.02 3.99934 20.5493 4 20V4C4 3.45 4.196 2.979 4.588 2.587C4.98 2.195 5.45067 1.99934 6 2H13.175C13.4417 2 13.696 2.05 13.938 2.15C14.18 2.25 14.3923 2.39167 14.575 2.575L19.425 7.425C19.6083 7.60834 19.75 7.821 19.85 8.063C19.95 8.305 20 8.559 20 8.825V20C20 20.55 19.804 21.021 19.412 21.413C19.02 21.805 18.5493 22.0007 18 22H6ZM13 8C13 8.28334 13.096 8.521 13.288 8.713C13.48 8.905 13.7173 9.00067 14 9H18L13 4V8Z",
    fill: "white",
    fillOpacity: 0.87
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/Submit.776fc81b4305565199234c2e232bc1e7.svg";
export { ForwardRef as ReactComponent };